import StringUtil from './StringUtil';

export default class ExportUtil {

    static export(options, pagination, url, isPost) {
        const params = {
            offest: 1,
        };
        options = options || {};
        Object.keys(options).forEach(key => {
            if (typeof options[key] !== 'object') {
                params[key] = options[key];
            }
        });
        if (pagination) {
            params.limit = pagination.total || 0;
        }
        const { invId, userId, siteId, curRole, positionRole, curEnterpriseId, curEmployeeCode, blindType, relatedSiteId } = sessionStorage;

        if (curEnterpriseId > 0) {
            params.curEnterpriseId = curEnterpriseId;
        }
        if (userId > 0) {
            params.curUserId = userId;
        }
        if (invId > 0) {
            params.curInvId = invId;
        }
        if (siteId > 0) {
            params.curSiteId = siteId;
        }
        if (!StringUtil.isNull(curRole)) {
            params.curRoleCode = curRole;
        }
        if (!StringUtil.isNull(curEmployeeCode)) {
            params.curEmployeeCode = curEmployeeCode;
        }
        if (!StringUtil.isNull(positionRole)) {
            params.curPositionRoleCode = positionRole;
        }
        if (!StringUtil.isNull(blindType)){
            params.blindType = blindType;
        }
        if (!StringUtil.isNull(relatedSiteId)){
            params.relatedSiteId = relatedSiteId;
        }

        let locationRef = url + '?';

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.style.height = 0;
        if (isPost) {
            const form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', url);
            if (params) {
                for (let [key, value] of Object.entries(params)) {
                    if (value != null) {
                        const input = document.createElement('input');
                        input.setAttribute('name', key);
                        input.setAttribute('value', value);
                        form.appendChild(input);
                    }
                }
            }
            iframe.appendChild(form);
            document.body.appendChild(iframe);
            form.submit();
        } else {
            if (params) {
                for (let [key, value] of Object.entries(params)) {
                    if (value != null) {
                        locationRef += '&' + encodeURIComponent(key) + "=" + encodeURIComponent(value);
                    }
                }
            }
            iframe.src = locationRef;
            document.body.appendChild(iframe);
        }
        setTimeout(() => {
            iframe.remove();
        }, 10 * 60 * 1000);
    }
}



// WEBPACK FOOTER //
// ./src/common/ExportUtil.js